import {
  XUtils
} from '../common/globals'

export * from './error'
export * from './passport'
export * from './mqtt-room'

const CONST = XUtils.getConst()

const ROOM_ID = XUtils.q2o(location.search.slice(1)).roomId || 31
const {
  CORP,
  CORP_XS,
  ENV_MODE,
  HOST_BBS,
  HOST_API,
  HOST_WEB,
  HOST_STATIC,
  HOST_PASSPORT
} = CONST

export {
  CORP,
  CORP_XS,
  ENV_MODE,
  HOST_BBS,
  HOST_API,
  HOST_WEB,
  HOST_STATIC,
  HOST_PASSPORT,

  ROOM_ID
}

// 订单
export const ORDER_SCENE_XS_SHOP = 10
export const ORDER_SCENE_XS_BIZ = 11

// 时间
export const MS_SECOND = 1000
export const MS_MINUTE = 60000
export const MS_HOUR = 60 * MS_MINUTE
export const MS_DAY = 24 * MS_HOUR
